import { render, staticRenderFns } from "./DHSchemaInfo.vue?vue&type=template&id=62120f6e&scoped=true&"
import script from "./DHSchemaInfo.vue?vue&type=script&lang=js&"
export * from "./DHSchemaInfo.vue?vue&type=script&lang=js&"
import style0 from "./DHSchemaInfo.vue?vue&type=style&index=0&id=62120f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62120f6e",
  null
  
)

export default component.exports